import { render, staticRenderFns } from "./CommissionAgreementChangesDetected.vue?vue&type=template&id=1f820766&"
import script from "./CommissionAgreementChangesDetected.vue?vue&type=script&lang=js&"
export * from "./CommissionAgreementChangesDetected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports